export var TypeActionLoading;
(function (TypeActionLoading) {
    TypeActionLoading["Start"] = "Load > Start";
    TypeActionLoading["Progress"] = "Load > Progress";
    TypeActionLoading["Complete"] = "Load > Complete";
    TypeActionLoading["Error"] = "Load > Error";
})(TypeActionLoading || (TypeActionLoading = {}));
export var actionLoadingStart = function (bundleId, loader) { return ({
    bundleId: bundleId,
    hasError: false,
    isLoaded: false,
    loader: loader,
    progress: 0,
    type: TypeActionLoading.Start,
}); };
export var actionLoadingProgress = function (bundleId, loader) { return ({
    bundleId: bundleId,
    hasError: false,
    isLoaded: loader.progress === 100,
    loader: loader,
    progress: loader.progress,
    type: TypeActionLoading.Progress,
}); };
export var actionLoadingComplete = function (bundleId, loader) { return ({
    bundleId: bundleId,
    hasError: false,
    isLoaded: true,
    loader: loader,
    progress: 100,
    type: TypeActionLoading.Complete,
}); };
export var actionLoadingError = function (bundleId, loader) { return ({
    bundleId: bundleId,
    hasError: true,
    isLoaded: false,
    loader: loader,
    progress: 0,
    type: TypeActionLoading.Error,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/loading/actionLoading.ts
// module id = 160
// module chunks = 3